import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.css']
})
export class RegisterComponent {
	username: string = '';
	password: string = '';
	conferma_password: string = '';
	nomeCompleto: string = '';
	email: string = '';
	codice_fiscale: string = '';

	constructor(private authService:AuthService, private router:Router) {}

	checkFields() {
		if (this.username.length &&
			this.password.length &&
			(this.password == this.conferma_password) &&
			this.email.length &&
			this.codice_fiscale.length) {
			return true;
		}
		else {
			return false;
		}
	}

	onRegisterSubmit() {
		const user = {
			username: this.username,
			password: this.password,
			email: this.email,
			nomeCommpleto: this.nomeCompleto,
			certificazione: false,
			codice_fiscale: this.codice_fiscale
		}

		this.authService.registerUser(user).subscribe(
			data => {
				console.log('REGISTER RESPONSE',data);
				if (data.success) {
					console.log('REGISTER SUCCESS');
					this.router.navigate(['login']);
				}
				else {
					this.router.navigate(['register']);
				}
			}
		);
	}
}
